import { CurrentBrand, TeamMember } from 'modules/Types';
import { GridColDef } from '@mui/x-data-grid';
import Avatar from '@mui/material/Avatar';
import { Body2, Caption } from 'components/shareable/Typography';
import ArtistThumbnailsSection from 'components/ArtistsThumbnail';
import gravatar from "gravatar";
import Colors from 'modules/Colors';
import ButtonSymphony from 'elements/ButtonSymphony';
import { MEMBER_ROLES_NAMES } from 'modules/Const';
import { OrganizationRoles } from 'modules/Types';

const { MEMBER, OWNER } = OrganizationRoles;

const DEFAULT_COL_PROPS: GridColDef = {
  field: "field",
  headerName: "column",
  type: "string",
  editable: false,
  align: "center",
  flex: 1,
}

const teamColumnsTemplate = (
  openEditMemberModal: (member: TeamMember) => void,
  loadedBrandsDict: Record<number, CurrentBrand>
) => {
  return [
    {
      ...DEFAULT_COL_PROPS,
      field: "details",
      align: 'left',
      headerAlign: 'left',
      width: 200,
      minWidth: 300,
      maxWidth: 400,
      renderCell: (params) => {
        const teamMember = params.row as TeamMember;
        const { name, lastName, email, isCurrentUser } = teamMember;
        return (
          <div className='flex gap-4 items-center max-w-full overflow-hidden'>
            <Avatar src={gravatar.url(email, { protocol: 'https', d: 'retro' })} sx={{ width: 32, height: 32 }} />
            <div className='flex flex-col gap-1 overflow-ellipsis' style={{ maxWidth: '84%' }}>
              {name && lastName && (
                <Body2
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textWrap: 'nowrap',
                  }}
                  color={Colors.textColor}
                >
                  {name} {lastName}
                </Body2>
              )}
              <Body2
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textWrap: 'nowrap',
                }}
              >
                {email}
              </Body2>
              {isCurrentUser && <Caption color={Colors.purple}>Your Profile</Caption>}
            </div>
          </div>
        )
      },
    },
    {
      ...DEFAULT_COL_PROPS,
      field: "role",
      align: 'center',
      headerAlign: 'center',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        const teamMember = params.row as TeamMember;
        return (
          <div className='pl-4'>
            <Body2 color={Colors.textColor}>{MEMBER_ROLES_NAMES[teamMember.role].name}</Body2>
          </div>
        )
      },
    },
    {
      ...DEFAULT_COL_PROPS,
      field: "artistsThumbnails",
      align: 'left',
      headerAlign: 'left',
      width: 100,
      minWidth: 150,
      maxWidth: 250,
      renderCell: (params) => {
        const teamMember = params.row as TeamMember;
        const { brands } = teamMember;
        return (
          <ArtistThumbnailsSection thumbnails={(brands || []).map(brand => loadedBrandsDict[brand.id]?.image ?? '')} />
        )
      },
    },
    {
      ...DEFAULT_COL_PROPS,
      field: "artistsCount",
      align: 'right',
      headerAlign: 'right',
      width: 150,
      minWidth: 180,
      maxWidth: 250,
      renderCell: (params) => {
        const teamMember = params.row as TeamMember;
        const { role, brands } = teamMember;
        const brandsCount = brands?.length || 0;

        if(role === OWNER) {
          return null;
        }

        return (
          <div className='pr-4'>
            <ButtonSymphony
              className="buttonCanViewProfiles"
              onClick={() => openEditMemberModal(teamMember)}
              variant="text"
            >
              {role === MEMBER ?
                // `Access to ${brandsCount} ${pluralize('brand', brandsCount)}`
                'Edit permissions'
                :
                'Edit permissions'
              }
            </ButtonSymphony>
          </div>
        )
      },
    },
  ] as GridColDef[];
}

export default teamColumnsTemplate;